import { render, staticRenderFns } from "./unicons.vue?vue&type=template&id=5ece37d4&"
import script from "./unicons.vue?vue&type=script&lang=js&"
export * from "./unicons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports